module.exports = __webpack_public_path__ + "media/customizations/sunterralakeslife/logo-new-a98a200001dded705498f93532a3f19d.png";